export const NEAR_WITHDRAW_KEY = 'REF_FI_NEAR_WITHDRAW_VALUE';
